import { CartItemInterface, ProductInterface } from '@pylot-data/pylotschema'
import { getCategoryName } from './getCategoryName'
import { getItemCategoryName } from './getItemCategoryName'

export const getPlpItemCategory = (
    data: ProductInterface | CartItemInterface
): string =>
    getItemCategoryName(data) || getCategoryName(data as ProductInterface)
